import { useRef, useEffect } from "react";

/**
 *
 * @param {import("src/js-docs/src/components").myCallback} cb Callback function to run once the condition is met
 * @param {boolean} condition The condition which the useeffect will rely on
 * @note Ideal for calling functions once, but only after some state needs to be loaded
 */
export default function useUpdateEffectOnce(cb, condition = true) {
  const isCalledRef = useRef(false);

  useEffect(() => {
    if (condition && !isCalledRef.current) {
      isCalledRef.current = true;
      cb();
    }
  }, [cb, condition]);
}
